/**
 * OverviewBarControls Component
 *
 * Slim-bar timeline sparkline + map for the Overview tab, bound to the IRP-wide
 * report locations. Thin wrapper over the reusable TimelineMapControls.
 */

import React from 'react';
import TimelineMapControls from './TimelineMapControls';
import {useReportLocationsCache} from '../../../../../../stores/irp-workbook.store';

const OverviewBarControls: React.FC = () => {
    const reportLocationsCache = useReportLocationsCache();
    const reports = Array.isArray(reportLocationsCache) ? reportLocationsCache : [];
    return <TimelineMapControls reports={reports} />;
};

export default OverviewBarControls;
